import { CompositeScreenProps } from '@react-navigation/native'
import { NavMenuButton } from 'components/partials/MobileNav/types'
import { Page } from 'components/partials/Page'
import { Box } from 'components/widgets/Box'
import { useTheme } from 'contexts'
import React, { useEffect, useState } from 'react'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { LoadingSpinner } from 'widgets/LoadingSpinner'
import { Backdrop } from 'widgets/Modal/styled'
import { ScrollView } from 'widgets/ScrollView'

import { useProgram } from 'hooks/useProgram'

import { ProgramTags } from 'types/program'

import { DiscoveryTagsSection } from './subcomponents/DiscoveryTagsSection'
import { Header } from './subcomponents/Header'
import { ProgramGroupsSection } from './subcomponents/ProgramGroupsSection'
import { WorkoutsSection } from './subcomponents/WorkoutsSection'

export const EditProgramPage = ({ route, navigation }: CompositeScreenProps<any, any>) => {
  const theme = useTheme()
  const insets = useSafeAreaInsets()

  const programId = route?.params?.programId
  const { data: program, updateProgram, isLoading } = useProgram(programId)

  const [saving, setSaving] = useState<boolean>(false)
  const [hasChanges, setHasChanges] = useState<boolean>(false)

  const [title, setTitle] = useState<string>('')
  const [description, setDescription] = useState<string>('')
  const [tags, setTags] = useState<ProgramTags | undefined>(program?.tags)

  const handleSave = async () => {
    if (!program || !hasChanges) return
    setSaving(true)
    await updateProgram.mutateAsync({
      ...program,
      title,
      description,
      tags,
    })
    setSaving(false)
    navigation.goBack()
  }

  const handleInfoChange = (newTitle: string, newDescription: string) => {
    if (!program?.title || !program?.description) return
    setHasChanges(program.title !== newTitle || program.description !== newDescription)
    setTitle(newTitle)
    setDescription(newDescription)
  }

  useEffect(() => {
    if (!tags || !program?.tags) return
    const newTagValues = []
      .concat(...Object.values(tags))
      .sort()
      .toString()
    const oldTagValues = []
      .concat(...Object.values(program?.tags))
      .sort()
      .toString()
    setHasChanges(newTagValues !== oldTagValues)
  }, [tags, program?.tags])

  const navSaveButton: NavMenuButton = {
    title: 'Save',
    titleColor: hasChanges ? 'v2primary' : 'grey',
    onPress: handleSave,
  }

  return (
    <>
      <Page
        withNav
        withBack
        isLoading={isLoading}
        navigation={navigation}
        title='Edit Program'
        navbarRightButtons={[navSaveButton]}
        backgroundColor='white'
      >
        <Box flex={1} margin={{ horizontal: 'smd', bottom: insets.bottom }}>
          <ScrollView keyboardDismissMode='on-drag' style={{ paddingHorizontal: theme.spacing.sm }}>
            <Header program={program} onChange={handleInfoChange} />
            <DiscoveryTagsSection programTags={tags} onChange={setTags} />
            <ProgramGroupsSection program={program} />
            <WorkoutsSection program={program} />
            <Box margin='xl' />
          </ScrollView>
        </Box>
      </Page>

      {saving && (
        <Backdrop
          style={{ position: 'absolute', justifyContent: 'center', alignContent: 'center' }}
        >
          <LoadingSpinner />
        </Backdrop>
      )}
    </>
  )
}
